module.exports = __webpack_public_path__ + "static/media/table2.eb31b3a9.jpg";